import React, { Component } from 'react'
import clsx from 'clsx'
import shortid from 'shortid'

import './toggle.css'

export default class Toggle extends Component {
  constructor(props) {
    super(props)
    this.uniqueId = shortid.generate()
  }

  onFocus = () => {
    this.props.onInputFocus && this.props.onInputFocus()
  }

  onBlur = () => {
    this.props.onInputBlur && this.props.onInputBlur()
  }

  onChange = (event) => {
    this.props.onToggle && this.props.onToggle(event)
  }

  render() {
    const labelClassName = clsx({
      'formz-switch-toggle-label': true,
    })

    const inputClassName = clsx({
      'formz-switch-toggle-input': true,
      'formz-input-hidden': true,
    })

    return (
      <div className="formz-material-toggle-switch">
        <input
          type="checkbox"
          id={this.uniqueId}
          name={this.props.name || 'toggle'}
          className={inputClassName}
          onChange={this.onChange}
          checked={this.props.toggled}
          disabled={this.props.disabled}
        />
        <label
          htmlFor={this.uniqueId}
          className={labelClassName}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
      </div>
    )
  }
}
